import styled from "styled-components"
import { breakpointSmall } from "../../variables"
import Img from "gatsby-image/withIEPolyfill"

export const Article = styled.article`
  max-width: ${({ maxWidth }) => maxWidth};
  width: ${({ width }) => width};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};

  iframe {
    width: 100%;
    height: 500px;
    display: block;
    margin: 50px 0;
  }
`

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection && flexDirection};
  justify-content: ${({ justifyContent }) => justifyContent && justifyContent};
  align-items: ${({ alignItems }) => alignItems && alignItems};
  width: ${({ width }) => (width ? width : "fit-content")};
  height: ${({ height }) => (height ? height : "fit-content")};
  padding: ${({ padding }) => padding && padding};

  @media (min-width: ${breakpointSmall}) {
    height: ${({ heightMd, height }) => (heightMd ? heightMd : height)};
    width: ${({ widthMd, width }) => (widthMd ? widthMd : width)};
    padding: ${({ padding, paddingMd }) => (paddingMd ? paddingMd : padding)};
    flex-direction: ${({ flexDirection, flexDirectionMd }) =>
      flexDirectionMd ? flexDirectionMd : flexDirection};
    justify-content: ${({ justifyContent, justifyContentMd }) =>
      justifyContentMd ? justifyContentMd : justifyContent};
    align-items: ${({ alignItems, alignItemsMd }) =>
      alignItemsMd ? alignItemsMd : alignItems};
  }
`

export const Section = styled.section`
  width: ${({ width }) => (width ? width : "100%")};
  height: ${({ height }) => (height ? height : "fit-content")};
  min-height: ${({ minHeight }) => minHeight};
  padding: ${({ padding }) => padding && padding};
  display: ${({ display }) => (display ? display : "block")};
  grid-template-columns: ${({ gtc }) => (gtc ? gtc : "none")};
  grid-template-rows: ${({ gtr }) => (gtr ? gtr : "none")};
  place-items: ${({ placeItens }) => (placeItens ? placeItens : "none")};
  justify-content: ${({ justifyContent }) =>
    justifyContent ? justifyContent : "none"};
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "none")};
  margin: ${({ margin }) => (margin ? margin : "initial")};

  @media (min-width: ${breakpointSmall}) {
    height: ${({ heightMd, height }) => (heightMd ? heightMd : height)};
    width: ${({ widthMd, width }) => (widthMd ? widthMd : width)};
    margin: ${({ marginMd, margin }) => (marginMd ? marginMd : margin)};
    padding: ${({ padding, paddingMd }) => (paddingMd ? paddingMd : padding)};
    display: ${({ display, displayMd }) => (displayMd ? displayMd : display)};
    grid-template-columns: ${({ gtc, gtcMd }) => (gtcMd ? gtcMd : gtc)};
    grid-template-rows: ${({ gtr, gtrMd }) => (gtrMd ? gtrMd : gtr)};
    place-items: ${({ placeItens, placeItensMd }) =>
      placeItensMd ? placeItensMd : placeItens};
    justify-content: ${({ justifyContent, justifyContentMd }) =>
      justifyContentMd ? justifyContentMd : justifyContent};
    align-items: ${({ alignItems, alignItemsMd }) =>
      alignItemsMd ? alignItemsMd : alignItems};
  }
`

export const ImageContainer = styled(Img)`
  width: ${({ width }) => (width ? width : "initial")};
  height: ${({ height }) => (height ? height : "initial")};
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "initial")};
  margin: ${({ margin }) => (margin ? margin : "initial")};
  @media (min-width: ${breakpointSmall}) {
    height: ${({ heightMd, height }) => (heightMd ? heightMd : height)};
    width: ${({ widthMd, width }) => (widthMd ? widthMd : width)};
    margin: ${({ marginMd, margin }) => (marginMd ? marginMd : margin)};
  }
`

